export { default as HorizontalRule } from './HorizontalRule';
